export enum AlertType {
  Success = 'toast-success',
  Error = 'toast-error',
  Warning = 'toast-warning',
  Primary = 'toast-primary',
}
